import React, { useState, useEffect } from "react";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Carousel } from "react-responsive-carousel";
import { useLocation } from "react-router-dom";
import axios from "axios";
// import Carousel from "react-bootstrap/Carousel";
import "./AdvertismentDetail.css";

const AdvertismentDetails = () => {
  const location = useLocation();
  const { from } = location.state;

  console.log("from", from);

  return (
    <>
      <h1 className="Adv_details">Check Details </h1>
      <table className="table">
        <thead>
          <tr>
            <th scope="col">Category</th>
            <th scope="col">Description</th>
            <th scope="col">Dimensions</th>
            <th scope="col">Whatsapp</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>{from.category}</td>
            <td>{from.description}</td>
            <td>{from.dimensions}</td>
            <td>{from.whatsapp}</td>
          </tr>
        </tbody>
      </table>
      <div className="main-class">
        <Carousel>
          {from?.images?.map((image, index) => {
            return (
              <div key={index}>
                <img
                  src={`http://localhost:5000/ads/image/${image}`}
                  className="d-block w-100"
                  alt="..."
                />
              </div>
            );
          })}
        </Carousel>
      </div>
    </>
  );
};

export default AdvertismentDetails;
